var _defs, _rect, _g, _path, _circle, _g2, _circle2, _circle3, _g3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10076IconServiceApplicationGateways(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "acac5a34-a032-49f9-9397-37f4f1b4ae9a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f6d5399b-a5cb-4c09-96cc-9e3bb1af2386",
    x1: 9,
    y1: 19.25,
    x2: 9,
    y2: -0.46,
    gradientTransform: "translate(9 -3.73) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6dad2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76bc2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a43242a2-4d95-4f6d-8870-2702ceb6aebc",
    x1: 7.54,
    y1: 6.44,
    x2: 7.53,
    y2: 5.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eedce6dd-706a-43c4-ac66-66b73578221d",
    x1: 9.36,
    y1: 7.69,
    x2: 9.36,
    y2: 6.57,
    href: "#a43242a2-4d95-4f6d-8870-2702ceb6aebc"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.82,
    y: 2.82,
    width: 12.35,
    height: 12.35,
    rx: 0.57,
    transform: "translate(-3.73 9) rotate(-45)",
    fill: "url(#f6d5399b-a5cb-4c09-96cc-9e3bb1af2386)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.89,10.51h2.84a.11.11,0,0,0,.1-.11V7.57a.1.1,0,0,0-.18-.07l-.78.78,0,.05a.1.1,0,0,1-.14,0L9.26,4.91a.1.1,0,0,0-.14,0l-.88.88a.11.11,0,0,0,0,.15l3.41,3.41a.11.11,0,0,1,0,.15l-.05.05-.78.78A.11.11,0,0,0,10.89,10.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92,10.51H4.08A.11.11,0,0,1,4,10.4V7.57a.1.1,0,0,1,.17-.07l.79.78,0,.05a.1.1,0,0,0,.14,0L8.55,4.91a.1.1,0,0,1,.14,0l.88.88a.11.11,0,0,1,0,.15L6.16,9.35a.11.11,0,0,0,0,.15l0,.05.78.78A.11.11,0,0,1,6.92,10.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82,13.07l2,2a.1.1,0,0,0,.14,0l2-2a.1.1,0,0,0-.07-.17H9.72a.11.11,0,0,1-.1-.1V8a.1.1,0,0,0-.1-.11H8.28A.11.11,0,0,0,8.17,8V12.8a.1.1,0,0,1-.1.1H6.89A.1.1,0,0,0,6.82,13.07Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ac0a9c0c-2e8c-4843-b02b-2fadf76b27d0",
    d: "M10.65,7.78A2.71,2.71,0,0,1,7.33,3.5l0,0a2.71,2.71,0,0,1,3.29,4.3",
    fill: "#0078d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53,
    cy: 5.55,
    r: 0.87,
    fill: "url(#a43242a2-4d95-4f6d-8870-2702ceb6aebc)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.67,7l.19.3L7,7.5a5.94,5.94,0,0,1,.34-1.1.85.85,0,0,1-.45-.23A6.71,6.71,0,0,0,6.67,7Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24,4.73A4,4,0,0,1,7,3.8a2.48,2.48,0,0,0-.34.46A3.51,3.51,0,0,0,6.86,5,1,1,0,0,1,7.24,4.73Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17,6.14a.87.87,0,0,1-.48.26,4.62,4.62,0,0,0,.46.41,4.14,4.14,0,0,0,.65.39V7.13A.53.53,0,0,1,9,6.73,3.6,3.6,0,0,1,8.17,6.14Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79,7.2a4.14,4.14,0,0,1-.87-.1v0a.55.55,0,0,1-.16.39,3.84,3.84,0,0,0,1.08.08,2.93,2.93,0,0,0,.37-.42Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36,
    cy: 7.13,
    r: 0.56,
    fill: "url(#eedce6dd-706a-43c4-ac66-66b73578221d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.64,
    cy: 5.74,
    r: 0.6,
    fill: "#f2f2f2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.21,4.42A4.29,4.29,0,0,1,11.09,4a2.24,2.24,0,0,0-.47-.45,4.5,4.5,0,0,0-1.49.35c-.1,0-.19.11-.29.16h0a5.85,5.85,0,0,1-.63-.93l-.34.13a5.35,5.35,0,0,0,.65,1,3.92,3.92,0,0,0-.67.55.87.87,0,0,1,.43.35,3.29,3.29,0,0,1,.61-.48,9.16,9.16,0,0,0,1.17,1,.57.57,0,0,1,.2-.32A8.44,8.44,0,0,1,9.21,4.42Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55,6.09h0l-.1,0h0l-.08,0h0l-.1-.06a.61.61,0,0,1-.2.3l.12.07h0l.11.06h0l.28.14h0a3.58,3.58,0,0,0,.09-.35Z",
    fill: "#f2f2f2",
    opacity: 0.55
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53,
    cy: 5.55,
    r: 0.87,
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36,
    cy: 7.13,
    r: 0.56,
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10076IconServiceApplicationGateways);
export default __webpack_public_path__ + "static/media/10076-icon-service-Application-Gateways.8ae1c2ddac616c13239593b453e13f7f.svg";
export { ForwardRef as ReactComponent };